import React from 'react';
import { cn } from '@/lib/utils';

export interface SidebarProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const Sidebar = React.forwardRef<HTMLDivElement, SidebarProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn('border-border bg-background flex h-full w-64 flex-col border-r', className)}
        {...props}
      >
        {children}
      </div>
    );
  },
);
Sidebar.displayName = 'Sidebar';

export interface MainContentProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const MainContent = React.forwardRef<HTMLDivElement, MainContentProps>(
  ({ className, children, ...props }, ref) => {
    // Contain absolute descendants (including sr-only labels) inside this scroller.
    return (
      <div
        ref={ref}
        className={cn('bg-background relative flex-1 overflow-auto px-3 py-3 md:p-4', className)}
        {...props}
      >
        {children}
      </div>
    );
  },
);
MainContent.displayName = 'MainContent';

export interface PageContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  maxWidth?: 'none' | 'narrow' | 'wide';
  children: React.ReactNode;
}

export const PageContainer = React.forwardRef<HTMLDivElement, PageContainerProps>(
  ({ maxWidth = 'none', className, children, ...props }, ref) => {
    const widthClass =
      maxWidth === 'wide'
        ? 'mx-auto w-full max-w-7xl'
        : maxWidth === 'narrow'
          ? 'mx-auto w-full max-w-3xl'
          : '';
    return (
      <div ref={ref} className={cn('space-y-6', widthClass, className)} {...props}>
        {children}
      </div>
    );
  },
);
PageContainer.displayName = 'PageContainer';
